// 过滤器

import Vue from 'vue'
import * as moment from 'moment'

//支付方式
Vue.filter("formatPayMet", function (value) {
  if (!value) {
    return ''
  } else {
    let res = ''
    if (value == 'wxpay') {
      res = '微信支付'
    } else if (value == 'alipay') {
      res = '支付宝支付'

    } else if (value == 'offline') {
      res = '线下支付'

    }
    return res
  }
})

//时间戳=> YYYY-MM-DD HH:mm:ss
Vue.filter("formatTime", function (value) {
  if (!value) {
    return ''
  } else {
    return moment(value).format('YYYY-MM-DD HH:mm:ss')
  }
})
Vue.filter('formatNumber', function (value) {
  if (value == null) {// value为0的时候也展示数据=>0.00
    return ''
  } else {
    // let realVal = parseFloat(value).toLocaleString('zh-Hans-CN', { style: 'currency', currency: 'CNY' })
    // return realVal
    const data = formatCny(value);
    return data
  }
})
function formatCny(data) {
  let decimalNum
  let Num
  var d = data.toString().split('.')
  if (d.length === 1) {
    data = separate(data.toString()) + '.00'
    return data
  }
  if (d.length > 1) {
    if (d[1].length < 2) {
      data = separate(d[0]) + '.' + d[1] + '0'
    } else if (d[1].length > 2) {
      decimalNum = Math.round(parseFloat(d[1].substr(0, 3)) / 10)
      if (decimalNum < 10 && decimalNum >= 0) {
        Num = '0' + decimalNum.toString()
      } else {
        Num = decimalNum.toString()
      }
      data = separate(d[0]) + '.' + Num
    } else {
      data = separate(d[0]) + '.' + d[1]
    }
    return data
  }
}
// 添加千位分隔符
function separate(str) {
  var re = /(?=(?!\b)(\d{3})+$)/g
  return str.replace(re, ',')
}

// 转换成大写
Vue.filter('toLocaleUpperCase', function (value) {
  if (value) {
    return value.toLocaleUpperCase()

  } else {
    return ''
  }
})

// 图片
Vue.filter('filterLink', function (value) {
  let imgUrl = process.env.IMG_URL
  if (value.indexOf('http')=='-1') {
    return imgUrl + value.replace(/\s*/g,'')
  } else {
    return value.replace(/\s*/g,'')
  }
})



// WEBPACK FOOTER //
// ./src/utils/filter.js